import { FC, useMemo } from 'react';

import { ReleaseNoteBoard } from '@shared/releaseNotes/ReleaseNoteBoard';
import { releaseNoteChannelsOfRole } from '@shared/releaseNotes/useReleaseNotes';
import { useAuth } from '@shared/state/hooks/useAuth';

import { useAdminTitleHook } from '../hooks/useAdminTitleHook';

/**
 * 관리자 콘솔의 업데이트 소식 — role이 볼 수 있는 모든 채널(Admin이면 전 채널).
 * 화면 본체는 @shared/releaseNotes/ReleaseNoteBoard (다른 콘솔과 공용).
 */
const AdminReleaseNotePage: FC = () => {
  useAdminTitleHook('업데이트 소식');

  const { roles } = useAuth();
  const channels = useMemo(() => releaseNoteChannelsOfRole(roles), [roles]);

  return <ReleaseNoteBoard channels={channels} />;
};

export default AdminReleaseNotePage;
